"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        // always visible and full screen height
        root: function () { return ({
            display: "flex",
            flexDirection: "column",
            width: "94px",
            minHeight: "100vh",
            maxHeight: "100vh",
            overflowY: "hidden",
            background: "linear-gradient(180deg, ".concat(theme.palette.primary.light, " 0%, ").concat(theme.palette.primary.dark, " 100%)"),
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[2],
            "& :after": {
                content: " ",
            },
        }); },
        // menu options at the start
        topMenu: {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
        },
        // secondary menu options at the end
        bottomMenu: {
            display: "flex",
            flexDirection: "column",
            paddingBottom: "88px",
        },
    });
});
